<template>
  <div :class="className" class="green-button" @click="$emit('click', $event)">
    <slot />
  </div>
</template>

<script>
  const THEMES = ['main'];

  export default {
    name: 'GreenButton',

    props: {
      theme: {
        type: String,
        default: 'main',
        validator: (value) => !value || THEMES.includes(value),
      },
    },

    computed: {
      className() {
        return `yellow-button--${this.theme}`;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .green-button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: clamp(4px, 0.85vw, 12px) clamp(16px, 6vw, 24px);
    color: var(--Colors-White, #fff);
    border-radius: 10px;
    background: linear-gradient(180deg, #17a34a 0%, #0c923d 100%);
    font-family: 'Barlow', sans-serif;
    font-weight: 600;
    text-shadow: none;
    min-width: 130px;
    font-size: clamp(12px, 1.05vw, 22px);
    user-select: none;
    cursor: pointer;

    &:hover {
      color: var(--Colors-Off-White, #f0f0f0);
    }

    &:active {
      filter: brightness(97%);
    }

    &[disabled] {
      pointer-events: none;
    }

    @media screen and (min-width: 1024px) {
      border-radius: 8px;
      font-size: clamp(14px, 1.25vw, 21px);
      padding: clamp(6px, 0.65vw, 12px) clamp(16px, 6vw, 24px);
    }

    @media screen and (min-width: 1280px) {
      font-size: clamp(14px, 1.2vw, 22px);
      padding: clamp(6px, 0.75vw, 12px) clamp(20px, 7vw, 30px);
      max-height: 60px;
    }
  }
</style>
